import React from "react";
import styled from "styled-components";
import { Theme } from "../../Theme";

// 전체 바의 배경 (회색 부분)
const ProgressBarContainer = styled.div`
    width: 100%;
    height: ${({ height }) => height}; /* 높이는 디자인에 따라 조절하세요 */
    background-color: #f0f0f0;
    border-radius: 8px;
    overflow: hidden;
`;

// 진행률을 나타내는 바 (청록색 부분)
const ProgressFiller = styled.div`
    height: 100%;
    /* 계산된 퍼센트 적용 */
    width: ${({ width }) => width}%;
    background-color: ${({ $activeColor }) => $activeColor}; /* 이미지와 유사한 테마 색상 */
    border-radius: inherit;
    transition: width 0.4s ease-in-out; /* 변화 시 부드러운 애니메이션 */
`;

const CustomProgressBar = ({ total, active, activeColor = Theme.color.cyan500, height = "6px" }) => {
    // 방어 코드: total이 0이거나 없을 경우 0%로 처리
    const percentage = total > 0 ? (active / total) * 100 : 0;

    // 100%를 넘지 않도록 제한
    const finalPercentage = Math.min(percentage, 100);

    return (
        <ProgressBarContainer height={height}>
            <ProgressFiller width={finalPercentage} $activeColor={activeColor} />
        </ProgressBarContainer>
    );
};

export default CustomProgressBar;
